import type { EventosConfiguracoes } from "@r3shared/types/WMS/configuracoes/events.types";
import { R3EventEmitter } from "../../../r3utils/src/events/emitter";

//import { R3EventEmitter } from "@r3utils/events/";

export default defineNuxtPlugin(() => {
  const eventEmitter = new R3EventEmitter<EventosConfiguracoes, {}>(
    ["show"],
    { createLogs: false, writeLog: false },
  );

  return {
    provide: {
      r3ConfiguracoesEvents: eventEmitter
    }
  };
});
